import * as React  from 'react'
import { connect } from 'react-redux'

import Grid from '@material-ui/core/Grid'

import { AccountType, AccountTypeInvitation, User }       from '../../api'
import { communicationToUiState }                         from '../../project-utils'
import { inviteUserRequest, selectMentees, usersRequest } from '../../redux'
import { FormikSubmissionCallBack }                       from '../forms/types'
import InviteUserForm, { InviteUserFields }               from '../forms/UserInviteForm'
import loadable                                           from '../hocs/loadable'
import { ActiveStatusFilterControls, UserList }           from '../molecules'

const mstp = state => ({
  mentees:                 selectMentees(state),
  inviteUserCommunication: inviteUserRequest.communicationSelector(state),
  getUsersCommunication:   usersRequest.communicationSelector(state),
})

const actions = {
  inviteUser:      inviteUserRequest.actionCreator,
  resetInviteUser: inviteUserRequest.resetActionCreator,

  getUsers: usersRequest.actionCreator,
}

type Props =
  ReturnType<typeof mstp>
  & typeof actions

interface State {
  displayByActive: boolean
}

class Mentees extends React.Component<Props, State> {
  public state = {
    displayByActive: true
  }

  private menteeList = loadable(({ users }: { users: User [] }) => (
    <UserList
      accountType={AccountType.Mentee}
      users={users}
    />
  ))

  public componentDidMount () {
    this.props.getUsers('mentee')
  }

  public componentWillUnmount () {
    this.props.resetInviteUser()
  }

  public render () {
    return (
      <Grid
        container
        direction={'column'}
        spacing={16}
      >
        <Grid item>
          {this.renderInviteMenteeForm()}
        </Grid>
        <Grid item>
          <ActiveStatusFilterControls
            active={this.state.displayByActive}
            setActiveFilter={this.setActiveFilter}
          />
        </Grid>
        <Grid item>
          {this.renderUserList()}
        </Grid>
      </Grid>
    )
  }

  private renderInviteMenteeForm = () => (
    <InviteUserForm
      accountType={AccountType.Mentee}
      onSubmit={this.invite}
      {...this.props.inviteUserCommunication}
    />
  )

  private renderUserList = () => {
    const MenteeList = this.menteeList
    const usersUiState = communicationToUiState(this.props.getUsersCommunication)
    return (
      <MenteeList
        ui={usersUiState}
        users={this.getDisplayedUsers()}
        isCached={!!this.props.mentees.length}
      />
    )
  }

  private setActiveFilter = (active: boolean) => {
    this.setState({
      displayByActive: active,
    })
  }

  private invite: FormikSubmissionCallBack<InviteUserFields> = ({ email }) => {
    this.props.inviteUser({ email, type: AccountTypeInvitation.Mentee })
  }

  private getDisplayedUsers = () =>
    this.props.mentees.filter(
      ({ account: { active } }) =>
        this.state.displayByActive === active
    )
}

export default connect(mstp, actions)(Mentees)



// WEBPACK FOOTER //
// ./src/components/environments/Mentees.tsx